<template>
  <div class="client-product-history-card border rounded-3 bg-light p-3">
    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
      <div class="fw-bold small">
        <AppIcon name="bi-clock-history" class="bi bi-clock-history me-1" />
        {{ $t('previous_sales_for_client') }}
      </div>
      <span class="text-muted small">{{ clientName }}</span>
    </div>

    <div v-if="loading" class="text-muted small py-2">
      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      {{ $t('loading') }}
    </div>
    <div v-else-if="loaded && !history.length" class="text-muted small py-1">
      {{ $t('no_previous_sales_for_client') }}
    </div>
    <div v-else class="table-responsive">
      <table class="table table-sm table-borderless align-middle mb-0 small">
        <thead>
          <tr class="text-muted">
            <th>{{ $t('date') }}</th>
            <th>{{ $t('reference') }}</th>
            <th>{{ $t('price') }}</th>
            <th>{{ $t('qty') }}</th>
            <th>{{ $t('discount') }}</th>
            <th v-if="canViewInvoiceDetails" class="text-end"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="sale in history" :key="sale.id">
            <td>{{ formatDate(sale.invoice.date) }}</td>
            <td>{{ sale.invoice.reference }}</td>
            <td class="fw-bold">{{ formatPrice(sale.price, sale.invoice.currency) }}</td>
            <td>{{ sale.quantity }}</td>
            <td>{{ Number(sale.discount) || 0 }}%</td>
            <td v-if="canViewInvoiceDetails" class="text-end">
              <a
                :href="$router.resolve({ name: 'InvoiceDetails', params: { id: sale.invoice.id } }).href"
                target="_blank"
                rel="noopener noreferrer"
                class="text-decoration-none text-nowrap"
              >
                {{ $t('view_details') }}
                <AppIcon name="bi-box-arrow-up-right" class="bi bi-box-arrow-up-right ms-1" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import helper from '../../helper'

export default {
  name: 'ClientProductSalesHistoryCard',
  props: {
    clientId: {
      type: String,
      required: true
    },
    clientName: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      required: true
    },
    excludeInvoiceId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      history: [],
      loading: false,
      loaded: false,
      requestKey: ''
    }
  },
  computed: {
    canViewInvoiceDetails() {
      return helper.checkAccess('view_invoices') !== -1
        && helper.checkAccess('view_invoices') !== -2
    }
  },
  watch: {
    clientId: 'fetchHistory',
    productId: 'fetchHistory',
    excludeInvoiceId: 'fetchHistory'
  },
  created() {
    this.fetchHistory()
  },
  methods: {
    async fetchHistory() {
      if (!this.clientId || !this.productId) return

      const requestKey = `${this.clientId}:${this.productId}:${this.excludeInvoiceId || ''}`
      this.requestKey = requestKey
      this.loading = true
      this.loaded = false
      this.history = []

      try {
        const params = new URLSearchParams({
          client_id: this.clientId,
          product_id: this.productId
        })
        if (this.excludeInvoiceId) params.set('exclude_invoice_id', this.excludeInvoiceId)

        const response = await helper.customGet(
          `${process.env.VUE_APP_API}/invoices/product-sales-history?${params.toString()}`
        )
        if (this.requestKey === requestKey) this.history = response.data || []
      } catch (error) {
        if (this.requestKey === requestKey) this.history = []
      } finally {
        if (this.requestKey === requestKey) {
          this.loading = false
          this.loaded = true
        }
      }
    },
    formatDate(date) {
      return helper.formatDate(date)
    },
    formatPrice(price, currency) {
      return helper.formatMoney(price, currency)
    }
  }
}
</script>

<style scoped>
.client-product-history-card {
  border-color: #d9e2ec !important;
}

.client-product-history-card .table > :not(caption) > * > * {
  background: transparent;
  padding: 0.35rem 0.5rem !important;
}
</style>
